import { render, staticRenderFns } from "./DeleteOverlay.vue?vue&type=template&id=0ac06180"
import script from "./DeleteOverlay.vue?vue&type=script&lang=js"
export * from "./DeleteOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports